import React from "react";
import "../DoctorConsole.scss";
import { DoctorconsoleGrid } from "../StyledComponents";
import { styles } from "../DoctorConsole.styles";

const Disclaimer = () => {
  return (
    <DoctorconsoleGrid style={styles.disclaimerGrid}>
      <h2 className="console-heading" style={styles.disclaimerHeading}>
        Statutory Notice
      </h2>
      <ul className="listItems">
        <li style={styles.disclaimerPoints}>
          HTMATE promotes AI assistance, not autonomy. AI-assisted outputs are
          advisory only. Please review and validate all prescription sections
          before submission. Final responsibility remains with the practitioner.
        </li>
        <li style={styles.disclaimerPoints}>
          In order to maintain a stricter immutability criteria of any health
          record, once a prescription gets submitted it cannot be altered or
          modified in future. In such a condition, it’s necessary to write a new
          prescription or consultation report.
        </li>
        <li style={styles.disclaimerPoints}>
          System leverages Ayushman Bharat Digital Mission (ABDM) Gateway
          (India) to aggregate patient’s medical records from PAN-India ABDM
          enabled providers and facilities upon request by doctors and consented
          by patients. System cannot guarantee any non-availability of health
          records for patients (ABDM gateway is maintained at a national level
          and failure points may be multiple and totally out of any control of
          Hlthtek).
        </li>
      </ul>
    </DoctorconsoleGrid>
  );
};

export default Disclaimer;
